import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../auth/services/auth.service';
import { LoginModel } from '../../../auth/models/login.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PermissionService } from '../../../auth/services/permission.service';

declare var KTComponents: any;
@Component({
  imports:[CommonModule, FormsModule],
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy  {

  loginData: LoginModel = {
    email: '',
    password: '',
    rememberMe: false
  };

  loading = false;
  error = '';

  constructor(
    private authService: AuthService,
    private router: Router,
    private renderer: Renderer2,
    private permissionService: PermissionService
  ) {}

  ngOnInit(){
    this.renderer.removeClass(document.body, 'flex');
    if(this.authService.getToken()){
    this.router.navigate(['/app']);
    }

  }

  ngOnDestroy(): void {
    this.renderer.addClass(document.body, 'flex');
  }


  login() {

    this.loading = true;

    this.authService.login(this.loginData)
      .subscribe({
        next: (res) => {

          this.loading = false;

          // if(res.requiresTwoFactor){
          //   this.router.navigate(['/otp'], { queryParams:{ userId: res.userId }});
          // }
          // else{
          //   this.authService.saveToken(res.accessToken!);
          //   this.router.navigate(['/app']);
          // }

          if(res.requiresTwoFactor){
            localStorage.setItem(
              "tempToken",
              res.tempToken!
            )
            this.router.navigate(['/verify-otp'])
          }
          else{
            this.authService.GetUserPermissions() 
              .subscribe(perms => {
                this.permissionService.setPermissions(perms)
              });
            // Save the token and navigate to the app
            this.authService.saveToken(res.accessToken!)
            
             // NAVIGATE
            this.router.navigate(['/app']).then(() => {

              // // 🔥 IMPORTANT
              // setTimeout(() => {

              //   try {

              //     if (typeof KTComponents !== 'undefined') {

              //       KTComponents.init();

              //       console.log('KTComponents initialized');
              //     }

              //   } catch (e) {
              //     console.error(e);
              //   }

              // }, 300);

            });
          }

        },
        error: () => {
          this.loading = false;
          this.error = "Invalid login credentials";
        }
      });
  }

}